export default "__VITE_ASSET__JB4rddMp__"